<div>
  <div *ngIf="text?.length > size">
    {{ readMore ? text : (text | slice: 0 : size) }} <span *ngIf="!readMore">...</span>
    <a role="button" tabindex="0" *ngIf="!readMore" (click)="readMore = true">Ver mais</a>
    <a role="button" tabindex="0" *ngIf="readMore" (click)="readMore = false">Ver menos</a>
  </div>

  <div *ngIf="text?.length <= size">
    <p [innerText]="text | replaceAll: '\\n' : '\n'"></p>
  </div>
</div>
